import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../common/constants";

export const ManagementOrganismScreenContainerStyle = createUseStyles((theme: any) => ({
    generalContainer: {
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 4.1rem)",
        width: "100%",
        overflow: "hidden",
    },
    header: {
        display: "flex",
        flexDirection: "row",
        textTransform: "uppercase",
        padding: 10,
        fontSize: "calc(5px + 0.6vw)",
        backgroundColor: theme.colors.palette.purpleLight,
        height: 50,
        alignContent: "center",
        alignItems: "center",
        fontWeight: theme.fonts.weight.bold,
        [mediaQueries.DISPLAY]: {
            fontSize: "18px !important",
        },
    },
    gridContent: {
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
    },
    row: {
        display: "flex",
        flexDirection: "row",
        padding: 10,
        height: 60,
        alignContent: "center",
        alignItems: "center",
        borderBottom: `1px solid ${theme.colors.palette.greyFooter}`,
        background: theme.colors.palette.white,
        fontSize: "calc(5px + 0.65vw)",
        color: theme.colors.palette.greyDark,
        [mediaQueries.DISPLAY]: {
            fontSize: "18px !important",
        },
    },
    rowAlternate: {
        background: theme.colors.palette.greyLighter,
    },
    cell: {
        display: "flex",
        flexWrap: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "16.66%",
        paddingRight: 5,
    },
    emptyState: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        fontSize: theme.fonts.sizes.xl,
        color: theme.colors.palette.grey,
        textAlign: "center",
        padding: 20,
    },
    timer: {
        fontSize: theme.fonts.sizes.xxl,
    },
}));
